import WorkModel from '../models/work';

import { WORK_FETCHED_SUCCESS } from '../constants/constants';

const work = {};

work.fetch = () => dispatch => {
  WorkModel.fetch().then(data => {
    dispatch(work.fetchedSuccess(data));
  });
};

work.fetchedSuccess = data => ({
  type: WORK_FETCHED_SUCCESS,
  payload: {
    data,
  },
});

export default work;



// WEBPACK FOOTER //
// ./src/actions/work.js